<div class="login" scOnEnter [action]="login">
    <div class="row container login__wrapper login__image">
        <div class="col-md-12 col-xs-12">
            <div class="login__header">
                <img src="assets/images/logo-160-x-64.svg" class="login__header-image" alt="Logo San Cristobal">
            </div>
        </div>
        <div class="col-md-12 desktop-hidden">
            <div class="login__greeting">
                <h1 class="login__title">Bienvenido al<br> portal de Productores</h1>
            </div>
        </div>
    </div>
    <div class="row container login__wrapper">
        <div class="col-md-7 col-xs-12 mobile-hidden">
            <div class="login__greeting">
                <h1 class="login__title">Bienvenido al portal de Productores</h1>
            </div>
        </div>
        <div class="col-md-5 col-xs-12">
            <div class="login__form-wrapper">
                <h3 class="login__subtitle">Ingresá con tus datos</h3>
                <div *ngIf="!!loginFormError" class="login__form-error mb-2">
                    <span class="sc-icon icon-alert-elipse-copy"></span>
                    <span class="login__form-error-message">{{loginFormError}}</span>
                </div>
                <form [formGroup]="loginFormGroup" class="mt-1" novalidate>
                    <div class="form-group mb-2">
                        <label for="nombre_usuario">Nombre de Usuario</label>
                        <input
                            [ngClass]="{'error': loginFormGroup.controls['username'].invalid && loginFormGroup.controls['username'].touched}"
                            type="text" formControlName="username" class="form-control" placeholder="Ingresá usuario"
                            id="nombre_usuario">
                        <span class="error_messages"
                            *ngIf="loginFormGroup.controls['username'].invalid && loginFormGroup.controls['username'].touched">
                            Ingresá tu usuario
                        </span>
                    </div>
                    <div class="form-group mb-2">
                        <label for="password">Contraseña</label>
                        <input
                            [ngClass]="{'error': loginFormGroup.controls['passwordHash'].invalid && loginFormGroup.controls['passwordHash'].touched}"
                            id="password" formControlName="passwordHash" type="password" class="form-control"
                            placeholder="Ingresá contraseña">
                        <span class="error_messages"
                            *ngIf="loginFormGroup.controls['passwordHash'].invalid && loginFormGroup.controls['passwordHash'].touched">
                            Ingresá tu contraseña
                        </span>
                    </div>
                    <div class="form-group mb-2">
                        <sc-button-2 id="login" [loading]="loading" [disabled]="loading" type="btn-primary fullWith"
                            body="Ingresá" isFullWidth="true" (onClick)="login($event)">
                        </sc-button-2>
                    </div>
                    <div>
                        <div class="login__form__row__other-links">
                            <a class="link" (click)="goForgottenPassword()">¿Olvidaste la contraseña?</a>
                            <a class="link" (click)="goSignUp()">Alta de usuario</a>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
